import React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor?: FillColor;
  className?: ClassName;
}

const CircleMinus = ({
  fillColor = '#3C3C3C',
  className = '',
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    className={className}
    viewBox="0 0 15 15"
    fill="none"
    aria-hidden={true}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M11.2438 8.55771H8.56947H6.43005H6.40972H3.75576C3.16582 8.55771 2.68605 8.07794 2.68605 7.48799C2.68605 6.89805 3.16582 6.41828 3.75576 6.41828H6.43005H11.2438C11.8337 6.41828 12.3135 6.89805 12.3135 7.48799C12.3135 8.07794 11.8337 8.55771 11.2438 8.55771ZM12.8034 2.19666C11.4459 0.839725 9.57072 0 7.49976 0C5.42879 0 3.55359 0.839725 2.19666 2.19666C0.83919 3.55412 0 5.42879 0 7.49976C0 9.57126 0.83919 11.4459 2.19666 12.8034C3.55359 14.1609 5.42879 15.0001 7.49976 15.0001C9.57072 15.0001 11.4459 14.1609 12.8034 12.8034C14.1603 11.4459 14.9995 9.57126 14.9995 7.49976C14.9995 5.42879 14.1603 3.55412 12.8034 2.19666Z"
        fill={fillColor}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { CircleMinus };
